enum UxStyleEnum {
  CIRCLE = "rounded-circle",
  BOXED = "boxed",
  ROUNDED = "rounded",
  EXTRA_ROUNDED = "extra-rounded"
}
export default UxStyleEnum;
